import './polyfills'

import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router, Switch } from "react-router-dom";

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { WagmiProvider, http } from 'wagmi'
import { RainbowKitProvider } from "@rainbow-me/rainbowkit";
import { ThemeProvider } from "@material-ui/core/styles";

import {
  GraphQLProvider,
  GraphQLConfig,
} from "./utils/grapgql/react-query-graphql.util";

import AlertState from "./store/Alert/AlertState";
import AuthState from "./store/Auth/AuthState";
import WalletState from "./store/Wallet/WalletState";
import { LearnState as LearnState2 } from "./store/Learn2/LearnState";
import SubscriptionState from "./store/Subscription/SubscriptionState";
import PoolState from "./store/Pool/PoolState";

import { config } from "./services/web3/wagmi";
import Disclaimer from "./components/ConnectWallet/Disclaimer";

import App from "./App";
import theme from "./helpers/theme";
import "../src/assets/scss/style.css";
import { appConfig } from './config';
import { AppRefreshTokenProvider } from './context/AppRefreshTokenContext';

const graphQLConfig: GraphQLConfig = {
  uri: appConfig.api.graphQL,
} as GraphQLConfig;

const queryClient = new QueryClient();
const wagmiConfig = config;

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <WagmiProvider config={wagmiConfig}>
        <QueryClientProvider client={queryClient}>
          <RainbowKitProvider
            appInfo={{
              appName: 'GainsPad',
              disclaimer: Disclaimer
            }}
          >
            <Router>
              <Switch>
                <GraphQLProvider {...graphQLConfig}>
                  <AppRefreshTokenProvider>
                    <AlertState>
                      <AuthState>
                        <WalletState>
                          <PoolState>
                            <SubscriptionState>
                              <LearnState2>
                                <App />
                              </LearnState2>
                            </SubscriptionState>
                          </PoolState>
                        </WalletState>
                      </AuthState>
                    </AlertState>
                  </AppRefreshTokenProvider>
                </GraphQLProvider>
              </Switch>
            </Router>
          </RainbowKitProvider>
        </QueryClientProvider>
      </WagmiProvider>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
